import { ChatCallPermission, ChatCallPermissionStatus } from '@/models/chat.model'

export function effectiveCallPermissionStatus(
  permission?: ChatCallPermission,
  now = Date.now()
): ChatCallPermissionStatus | null {
  if (!permission) return null
  if (permission.status === 'TEMPORARY' && (!permission.expirationTimestamp || permission.expirationTimestamp <= now)) {
    return 'EXPIRED'
  }
  return permission.status
}

export function isCachedPermissionDenied(permission?: ChatCallPermission) {
  const status = effectiveCallPermissionStatus(permission)
  return status === 'REJECTED' || status === 'EXPIRED'
}
